import { ComponentType } from 'react';
import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type LaunchScreenModule = {
    LaunchScreen: ComponentType;
};

@injectable()
export class LaunchScreenHostWidget extends ReactWidget {
    static readonly ID = 'widget:lvgl-launch-screen-host';

    protected LaunchScreen: ComponentType | undefined;
    protected loadError: string | undefined;

    @postConstruct()
    protected init(): void {
        this.id = LaunchScreenHostWidget.ID;
        this.title.closable = false;
        this.node.id = 'lvgl-launch-screen';
        void this.loadModule();
    }

    protected async loadModule(): Promise<void> {
        try {
            const mod = (await import('@lved/ui')) as unknown as LaunchScreenModule;
            this.LaunchScreen = mod.LaunchScreen;
        } catch (error: unknown) {
            this.loadError = error instanceof Error ? error.message : 'Failed to load Launch Screen.';
        }
        this.update();
    }

    protected override render(): JSX.Element {
        if (this.loadError) {
            return <p style={{ padding: '2rem', color: 'var(--theia-errorForeground)' }}>{this.loadError}</p>;
        }
        if (!this.LaunchScreen) {
            return <></>;
        }
        const LaunchScreen = this.LaunchScreen;
        return <LaunchScreen />;
    }
}
